module.exports = __webpack_public_path__ + "img/volume-up.f62c604f.svg";